module.exports = __webpack_public_path__ + "static/img/indexBack2.55aee58.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/indexBack2.png
// module id = D1lC
// module chunks = 0